<div class="card text-center shadow-sm bluebackground vesionwidth">
      <a class="stretched-link small" routerLink="/server/vesion" queryParamsHandling="merge"><img class="card-img img-fluid my-2" ngSrc="assets/images/images/VeSion_logo_final_transparent_update.png" alt="VeSion" width="601" height="259"/></a>
  </div>
